module.exports = __webpack_public_path__ + "static/media/no-stats.58989640.svg";